import type { AdminFamilyDetailDto, AdminFamilyListItemDto } from '@familychef/shared';
import { useQuery } from '@tanstack/react-query';

import { fetchAdminFamilies, fetchAdminFamilyDetail } from '../lib/admin-api';

export type FamilyRow = AdminFamilyListItemDto;

export function useFamilies(search: string) {
  return useQuery({
    queryKey: ['families', search],
    queryFn: () => fetchAdminFamilies(search),
  });
}

export type FamilyDetail = AdminFamilyDetailDto;

export function useFamilyDetail(id: string) {
  return useQuery<FamilyDetail>({
    queryKey: ['family', id],
    queryFn: () => fetchAdminFamilyDetail(id),
    enabled: !!id,
  });
}
